module.exports = __webpack_public_path__ + "static/media/realtalk_sd_sakurac57b9eb138fb3c17cc23e79700df730a.webp";